// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAsyrupusdt } from "../../../icons/mono/build/icon-asyrupusdt.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AsyrupusdtIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAsyrupusdt.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AsyrupusdtIcon.displayName = 'AsyrupusdtIcon';
}

export default AsyrupusdtIcon;